import React, { useState } from "react";

import "../Faqs/Faqs.css";

const Faqs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section
      id="faqsSrl"
      className="faqOuterSection py-8 md:py-12 px-2 sm:px-4 relative  overflow-hidden"
    >
      <div className="section_about-bg-gradient animate-pulse" />
      <div className="container rotateGradientAb relative">
        <div className="mb-6 sm:mb-12 text-center flex flex-col ">
          
          <h2 className="text-4xl text-center font-bold mx-auto  bg-gradient-to-br from-yellow-500 via-blue-500 to-yellow-400  text-transparent bg-clip-text leading-[3.25rem] mb-3 max-w-max lg:max-w-3xl lg:mx-auto">
            Frequently Asked Questions
          </h2>
          <p className="text-base font-normal text-gray-400 lg:max-w-2xl lg:mx-auto mb-8">
            Answers to your doubts.
          </p>
        </div>

        <div className="grid grid-cols-1  gap-6 mt-5 relative max-w-3xl mx-auto">
          <div className="rowtreebox">
            <div className="acd-faq">
              {faqData.slice(0, 4).map((item, index) => (
                <div key={index} className="acd-faq-item">
                  <h2 className="acd-faq-header mb-0">
                    <button
                      className={`acd-faq-button flex items-center w-full py-3 px-3 text-left transition ${
                        activeIndex === index ? "active" : ""
                      }`}
                      onClick={() => handleToggle(index)}
                      aria-expanded={activeIndex === index}
                    >
                      {item.question}
                      <svg
                        className={`ml-auto transform transition-transform ${
                          activeIndex === index ? "rotate-180" : ""
                        }`}
                        width="24"
                        height="24"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </button>
                  </h2>
                  <div
                    className={`acd-faq-body ${
                      activeIndex === index ? "open" : ""
                    }`}
                  >
                    <p className="text-justify">{item.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="rowtreebox">
            <div className="acd-faq">
              {faqData.slice(4, 8).map((item, index) => {
                const adjustedIndex = index + 4;
                return (
                  <div key={adjustedIndex} className="acd-faq-item">
                    <h2 className="acd-faq-header mb-0">
                      <button
                        className={`acd-faq-button flex items-center w-full py-3 px-3 text-left transition ${
                          activeIndex === adjustedIndex ? "active" : ""
                        }`}
                        onClick={() => handleToggle(adjustedIndex)}
                        aria-expanded={activeIndex === adjustedIndex}
                      >
                        {item.question}
                        <svg
                          className={`ml-auto transform transition-transform ${
                            activeIndex === adjustedIndex ? "rotate-180" : ""
                          }`}
                          width="24"
                          height="24"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </button>
                    </h2>
                    <div
                      className={`acd-faq-body ${
                        activeIndex === adjustedIndex ? "open" : ""
                      }`}
                    >
                      <p className="text-justify">{item.answer}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const faqData = [
  {
    question: "What is Exbit?",
    answer:
      "Exbit is a blockchain ecosystem built on Binance Smart Chain, offering a decentralized exchange, NFT liquidity farming, and blockchain gaming.",
  },
  {
    question: "What is Exbit Token (EXB)?",
    answer:
      "Exbit Token (EXB) is the native utility token of the Exbit ecosystem. It is used for a variety of purposes within the platform, including staking, liquidity farming, participating in governance, and playing games. EXB is designed to offer users a seamless and rewarding experience within the Exbit ecosystem.",
  },
  {
    question: "How can I acquire EXB tokens?",
    answer:
      "EXB tokens will be available for purchase once the Exbit DEX. Users can also acquire EXB tokens through the platform's NFT liquidity farming and staking programs, which allow users to earn rewards.",
  },
  {
    question: "What is the total supply of EXB tokens?",
    answer: (
      <>
        The total supply of EXB tokens is capped at 
        500,000,000 EXB with a
        significant portion allocated for community rewards, staking, liquidity
        farming, and ecosystem development.
      </>
    ),
  },
  // {
  //   question: "HOW DO I SET UP MY WALLET ON POLYGON CHAIN?",
  //   answer: (
  //     <>
  //       Trust Wallet: When you go into the dAPP in the top-right corner you can
  //       see the different blEXkchains available, click on it then choose Polygon
  //       Chain Mainnet. MetaMask: Create a custom RPC with the following: Polygon
  //       Mainnet in the Network Name field, URL:
  //       <a
  //         href=""
  //         target="_blank"
  //         rel="noopener noreferrer"
  //         className="text-blue-500 underline"
  //       >
  //         {" "}
  //       </a>{" "}
  //       in the New RPC URL field, 137 in Chain ID field, POL in Currency Symbol
  //       field and
  //       <a
  //         href=""
  //         target="_blank"
  //         rel="noopener noreferrer"
  //         className="text-blue-500 underline"
  //       >
  //         {" "}
  //       </a>{" "}
  //       in BlEXk Explorer URL field.
  //     </>
  //   ),
  // },
  // {
  //   question: "WHEN WILL YOU OPEN MORE POOLS?",
  //   answer:
  //     "There will always be an announcement before the launch of new pools. Join the announcements Telegram group to be the first that finds out.",
  // },
  // {
  //   question: "HOW DO I GET AIRDROPS?",
  //   answer:
  //     "When there is any official airdrop going on it will be announced along with the requirements. Please remember anyone can airdrop tokens to users since every transaction is public on PolygonScan. Do your own due diligence when it comes to non-official airdrops.",
  // },
  // {
  //   question: "WHY DOES IT SAY I HAVE NO POL BALANCE?",
  //   answer: (
  //     <>You're most likely not connected to Polygon Chain within your wallet.</>
  //   ),
  // },
];

export default Faqs;
